module.exports = __webpack_public_path__ + "e9acb05e72f7c34e0c885f9dd32af3fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/2_C#2.mp3
// module id = 59
// module chunks = 0